export function MixedFont({ inputText }) {
  const text = String(inputText);

  const parts = text.split(/([A-Za-z]+(?:['-][A-Za-z]+)*)/g);

  return (
    <>
      {parts.map((part, index) =>
        /^[A-Za-z]+(?:['-][A-Za-z]+)*$/.test(part) ? (
          <span className="english" key={index}>
            {part}
          </span>
        ) : (
          part
        ),
      )}
    </>
  );
}
